export { default } from './FacetPlanProposalNextUpReviewPageTemplate';
